/**
 * Door type names and the predicates that read them — the pure part of
 * `functions/shared/doorTypes.js`, moved here so the inspection's apply rules
 * (`shared-lib/existing-conditions/openingTypeApply.js`) run in the browser as
 * well as on the server. `functions/shared/doorTypes.js` re-exports these.
 * (web-app/src/constants/doorTypes.js still carries its own copy.)
 */
const DOOR_TYPES = {
  // Swing doors (single panel with hinge)
  LEFT_INSWING: 'leftInswing',
  RIGHT_INSWING: 'rightInswing',
  LEFT_OUTSWING: 'leftOutswing',
  RIGHT_OUTSWING: 'rightOutswing',

  // French doors (double panel, both swing)
  LEFT_ACTIVE_INSWING_FRENCH: 'leftActiveInswingFrench',
  RIGHT_ACTIVE_INSWING_FRENCH: 'rightActiveInswingFrench',
  LEFT_ACTIVE_OUTSWING_FRENCH: 'leftActiveOutswingFrench',
  RIGHT_ACTIVE_OUTSWING_FRENCH: 'rightActiveOutswingFrench',

  // Sliding doors (panels slide on track)
  LEFT_HANDLE_SLIDING: 'leftHandleSliding',
  RIGHT_HANDLE_SLIDING: 'rightHandleSliding',

  // Pocket doors (slide into wall cavity)
  // An overhead sectional door. Its own type because it is neither a
  // swing nor a slider: the panel lifts out of the opening on a track.
  // Width alone used to classify it as sliding.
  GARAGE: 'garageDoor',

  LEFT_HANDLE_POCKET: 'leftHandlePocket',
  RIGHT_HANDLE_POCKET: 'rightHandlePocket',

  // Barn doors (a slab on a surface track). The values contain "Sliding"
  // ON PURPOSE (design 6e): a barn door IS a surface-mounted slider, so every
  // renderer that asks `isSlidingDoor` draws it as one until it has a
  // drawing of its own; the estimate reads Barn before Sliding.
  LEFT_BARN: 'leftHandleBarnSliding',
  RIGHT_BARN: 'rightHandleBarnSliding',

  // Bifold doors (leaves that fold back on a track). They match no other
  // family: a renderer that knows none draws them shut, never nothing.
  LEFT_BIFOLD: 'leftBifold',
  RIGHT_BIFOLD: 'rightBifold',
};

const DEFAULT_DOOR_TYPE = DOOR_TYPES.LEFT_INSWING;

const isSlidingDoor = (doorType) => doorType?.includes('Sliding');

const isFrenchDoor = (doorType) => doorType?.includes('French');

const isPocketDoor = (doorType) => doorType?.includes('Pocket');

const isGarageDoor = (doorType) => doorType === DOOR_TYPES.GARAGE;

const isBarnDoor = (doorType) => String(doorType ?? '').includes('Barn');

const isBifoldDoor = (doorType) => String(doorType ?? '').includes('Bifold');

const isInswing = (doorType) => doorType?.includes('Inswing');

const isSwingDoor = (doorType) =>
  (doorType?.includes('Inswing') || doorType?.includes('Outswing')) &&
  !doorType?.includes('French');

module.exports = {
  DOOR_TYPES,
  DEFAULT_DOOR_TYPE,
  isSlidingDoor,
  isFrenchDoor,
  isPocketDoor,
  isGarageDoor,
  isBarnDoor,
  isBifoldDoor,
  isInswing,
  isSwingDoor,
};
